import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { assets } from "../assets/assets";

import DelhiLiveMapSection from "./DelhiLiveMapSection";
import AtmospoleVideo from "./videos/Atmospole.mp4";
import AtmospoleVideo2 from "./videos/Atmospole-video-2.mp4";
import FooterVideo from "./videos/footer-video.mp4";
import AtmospoleFeatureShowcase from "./AtmospoleFeatureShowcase";
import atmospoleNews from "../assets/atmospole-news2.png";
import atmospoleDocumentry from "../assets/atmospole-documentry.png";

const Home = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
    AOS.refresh();
  }, []);

  return (
    <>
      <div className="hydrotrace-video-banner relative-1" id="home">
        <div className="blue-bgimg">
          <img src={assets.bluebgimage} alt="Atmospole Banner Background" />
        </div>
        <div className="hydrotrace-video-text">
          <div className="hydrotrace-video-text-wrap max-width-1170 font-style-4">
            <h4 className="white-color" data-aos="fade-down">
              ATMOSPOLE<sup>™</sup>
            </h4>
            <h1 className="white-color">
              THE FUTURE OF INFRASTRUCTURE IS ALIVE.
            </h1>

            <p className="" data-aos="fade-up">
              Intelligent urban infrastructure designed to sense, respond and
              improve the environment around it.
            </p>

            <a href="#AtmosPOLE" className="hydrotrace-btn-1">
              EXPLORE ATMOSPOLE
            </a>
          </div>
        </div>

        <div className="homevideo_section_1">
          <video
            className="bg-video"
            autoPlay
            loop
            muted
            playsInline
            src={AtmospoleVideo}
            aria-hidden="true"
          />
        </div>
      </div>

      <div className="black-bg" id="AtmosPOLE">
        <div className="wrapper">
          <div className="atmospole-two-col-main">
            <div className="atmospole-two-col-1">
              <h3>WHAT IS ATMOSPOLE?</h3>
              <h2>INTELLIGENT INFRASTRUCTURE. BUILT FOR THE REAL WORLD.</h2>
              <p>
                AtmosPOLE brings environmental intelligence, air-quality
                monitoring, air treatment and connected urban infrastructure into
                a single physical platform.
              </p>
              <p>
                Designed for public environments, it transforms conventional city
                infrastructure into an intelligent system capable of understanding
                and responding to the conditions around it.
              </p>
            </div>
            <div className="atmospole-two-col-2">
              <video
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                autoPlay
                loop
                muted
                playsInline
                src={AtmospoleVideo2}
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="black-bg" id="how-it-works">
        <div className="wrapper">
          <div className="atmospole-two-col-main">
            <div className="atmospole-two-col-1">
              <h3>HOW ATMOSPOLE WORKS</h3>
              <h2>
                A SINGLE ASSET.
                <br />
                MULTIPLE SYSTEMS.
              </h2>
              <p>
                AtmosPOLE integrates multiple environmental and smart-city
                capabilities within one intelligent urban infrastructure
                platform.
              </p>
            </div>
          </div>
        </div>
      </div>

      <AtmospoleFeatureShowcase />

      <div className="black-bg" id="live-network">
        <div className="wrapper">
          <div className="atmospole-two-col-main">
            <div className="atmospole-two-col-1">
              <h3>LIVE NETWORK</h3>
              <h2>
                SEE THE CITY. <br />
                AS IT BREATHES.
              </h2>
              <p>
                Real-time environmental intelligence from active AtmosPOLE
                deployments across Delhi.
              </p>
            </div>
          </div>
        </div>
        <div className="map-section">
          <DelhiLiveMapSection />
        </div>
      </div>

      <div className="black-bg" id="media-coverage">
        <div className="wrapper">
          <div className="atmospole-two-col-main">
            <div className="atmospole-two-col-1">
              <h3>THE STORY DOESN’T STOP AT THE STREET.</h3>
              <h2>BEYOND THE INSTALLATION</h2>
              <p>
                Behind AtmosPOLE is a bigger idea for how cities can work. As the
                system takes its place in public spaces, the story extends beyond
                the technology itself—to the people, places and conversations
                around it.
              </p>
            </div>
          </div>
        </div>

        <div className="max-width-wrap margin-auto">
          <div className="new-hydrotrace-two-col-main">
            <div className="new-hydrotrace-two-col-1">
              <h4>NEWS</h4>
              <h2>ATMOSPOLE IN THE SPOTLIGHT</h2>
              <p>
                From its deployment in Delhi to the news coverage that followed,
                explore how AtmosPOLE is being put to work on the street. Hear
                from Tributum Power Private Limited CEO Sanjay Kommera on where the idea came from and
                how he believes it can help cities address air pollution.
              </p>
              <a
                href="https://www.youtube.com/watch?v=18Jf-xxZ8O4"
                target="_blank"
                rel="noopener noreferrer"
              >
                EXPLORE THE COVERAGE
              </a>
              <div className="imgsrcoll">
                <a
                  href="https://www.youtube.com/watch?v=18Jf-xxZ8O4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={atmospoleNews} alt="AtmosPOLE in the spotlight" />
                </a>
              </div>
            </div>

            <div className="new-hydrotrace-two-col-1">
              <h4>DOCUMENTARY</h4>
              <h2>SEE ATMOSPOLE IN ACTION</h2>

              <p>
                What does a streetlight do when it goes beyond lighting? Watch
                the documentary to see how AtmosPOLE is designed to monitor air
                quality, reduce pollution, and bring useful technology into
                public spaces.
              </p>
              <a
                href="https://www.youtube.com/watch?v=18Jf-xxZ8O4"
                target="_blank"
                rel="noopener noreferrer"
              >
                WATCH THE DOCUMENTARY
              </a>

              <div className="imgsrcoll">
                <a
                  href="https://www.youtube.com/watch?v=18Jf-xxZ8O4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={atmospoleDocumentry} alt="AtmosPOLE Documentary" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative-3">
        <div className="n-full-width-black">
          <h2>
            THE SYSTEM INFRASTRUCTURE THAT
            <br />
            UNDERSTANDS IT’S OWN ENVIRONMENT
          </h2>
          <p>
            Built to sense, respond and evolve with <br />
            the environments around us. Powered by Tributum Power Private Limited
          </p>
        </div>
      </div>

      <div className="full-img relative-1">
        <div className="abs-text-2">
          <img
            src={assets.footerlogos3}
            className="footer-logos-2"
            alt="Footer Logos"
          />
        </div>

        <div className="homevideo_section_1">
          <div className="abs-full-width-1">
            <div className="wrapper relative-3"></div>
          </div>

          <video
            className="bg-video-3"
            autoPlay
            loop
            muted
            playsInline
            src={FooterVideo}
            aria-hidden="true"
          />
        </div>
      </div>
    </>
  );
};

export default Home;
